import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { billingScopes } from '../../billing-consts';
import { getFullPath } from '../../lib/get-full-path';
import { GalleryService } from '../../services/gallery.service';
import { PermissionService } from '../../services/permission.service';
import { RedirectService } from '../../services/redirect.service';
import { ToastService } from '../../services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryAdvancedGuard {
  private permissionService = inject(PermissionService);
  private redirectService = inject(RedirectService);
  private galleryService = inject(GalleryService);
  private toasts = inject(ToastService);
  private platformId = inject<string>(PLATFORM_ID);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;

    const gallery = await this.galleryService.getPublicGalleryFromSnapshot(next, { isPublic: true });

    const allowAdvancedMode =
      this.permissionService.canDisplayElement(billingScopes.gallery.clientAdvancedMode, gallery) &&
      gallery.client_advanced_mode_enabled;

    if (!allowAdvancedMode) {
      this.toasts.add('Workflow is not allowed for this gallery', 'error');
      const path = getFullPath(next);
      const newPath = path.map(p => (p === 'advanced' ? '' : p));
      return this.redirectService.redirectTo(newPath, { queryParams: next.queryParams });
    }
    return true;
  }
}
